function TextSmall() {
  return (
    <blockquote className="p-4 bg-white">
      <h4 className="h6 mb-3">What It Means</h4>
      <p>Text is very small.</p>
      <h4 className="h6 mb-3">Why It Matters</h4>
      <p>Text which is very small is difficult to read, particularly for those with low vision.</p>
      <h4 className="h6 mb-3">What To Do</h4>
      <p>Increase the text to a more readable size.</p>
    </blockquote>
  )
}

export default TextSmall